const ADSENSE_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3964040172117553';

let loadPromise: Promise<void> | null = null;

/** Lazy-load AdSense script (only when an ad slot mounts). */
export function loadAdSenseScript(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();
  if (document.querySelector(`script[src^="${ADSENSE_SRC.split('?')[0]}"]`)) {
    return Promise.resolve();
  }
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = ADSENSE_SRC;
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('adsense_script_failed'));
    document.head.appendChild(script);
  });

  return loadPromise;
}
